function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { isChromium, isGecko, isWebKit } from "../util/browser";

// Types and constants are used instead of interfaces and enums to avoid this error in projects which use this library:
// Exported variable '...' has or is using name '...' from external module "..." but cannot be named.

/**
 * WebGL basic features
 */

/**
 * WebGL extended features
 */

/** WebGl context is not available */
export var STATUS_NO_GL_CONTEXT = -1;
/** WebGL context `getParameter` method is not a function */
export var STATUS_GET_PARAMETER_NOT_A_FUNCTION = -2;
var validContextParameters = new Set([10752, 2849, 2884, 2885, 2886, 2928, 2929, 2930, 2931, 2932, 2960, 2961, 2962, 2963, 2964, 2965, 2966, 2967, 2968, 2978, 3024, 3042, 3088, 3089, 3106, 3107, 32773, 32777, 32777, 32823, 32824, 32936, 32937, 32938, 32939, 32968, 32969, 32970, 32971, 3317, 33170, 3333, 3379, 3386, 33901, 33902, 34016, 34024, 34076, 3408, 3410, 3411, 3412, 3413, 3414, 3415, 34467, 34816, 34817, 34818, 34819, 34877, 34921, 34930, 35660, 35661, 35724, 35738, 35739, 36003, 36004, 36005, 36347, 36348, 36349, 37440, 37441, 37443, 7936, 7937, 7938
// SAMPLE_ALPHA_TO_COVERAGE (32926) and SAMPLE_COVERAGE (32928) are excluded because they trigger a console warning
// in IE, Chrome ≤ 59 and Safari ≤ 13 and give no entropy.
]);
var validExtensionParams = new Set([34047,
// MAX_TEXTURE_MAX_ANISOTROPY_EXT
35723,
// FRAGMENT_SHADER_DERIVATIVE_HINT_OES
36063,
// MAX_COLOR_ATTACHMENTS_WEBGL
34852,
// MAX_DRAW_BUFFERS_WEBGL
34853,
// DRAW_BUFFER0_WEBGL
34854,
// DRAW_BUFFER1_WEBGL
34229,
// VERTEX_ARRAY_BINDING_OES
36392,
// TIMESTAMP_EXT
36795,
// GPU_DISJOINT_EXT
38449 // MAX_VIEWS_OVR
]);
var shaderTypes = ['FRAGMENT_SHADER', 'VERTEX_SHADER'];
var precisionTypes = ['LOW_FLOAT', 'MEDIUM_FLOAT', 'HIGH_FLOAT', 'LOW_INT', 'MEDIUM_INT', 'HIGH_INT'];
var rendererInfoExtensionName = 'WEBGL_debug_renderer_info';
var polygonModeExtensionName = 'WEBGL_polygon_mode';

/**
 * Gets the basic and simple WebGL parameters
 */
export function getWebGlBasics(_ref) {
  var _gl$getParameter, _gl$getParameter2, _gl$getParameter3, _gl$getParameter4, _gl$getParameter5, _gl$getParameter6;
  var cache = _ref.cache;
  var gl = getWebGLContext(cache);
  if (!gl) {
    return STATUS_NO_GL_CONTEXT;
  }
  if (!isValidParameterGetter(gl)) {
    return STATUS_GET_PARAMETER_NOT_A_FUNCTION;
  }
  var debugExtension = shouldAvoidDebugRendererInfo() ? null : gl.getExtension(rendererInfoExtensionName);
  return {
    version: ((_gl$getParameter = gl.getParameter(gl.VERSION)) === null || _gl$getParameter === void 0 ? void 0 : _gl$getParameter.toString()) || '',
    vendor: ((_gl$getParameter2 = gl.getParameter(gl.VENDOR)) === null || _gl$getParameter2 === void 0 ? void 0 : _gl$getParameter2.toString()) || '',
    vendorUnmasked: debugExtension ? (_gl$getParameter3 = gl.getParameter(debugExtension.UNMASKED_VENDOR_WEBGL)) === null || _gl$getParameter3 === void 0 ? void 0 : _gl$getParameter3.toString() : '',
    renderer: ((_gl$getParameter4 = gl.getParameter(gl.RENDERER)) === null || _gl$getParameter4 === void 0 ? void 0 : _gl$getParameter4.toString()) || '',
    rendererUnmasked: debugExtension ? (_gl$getParameter5 = gl.getParameter(debugExtension.UNMASKED_RENDERER_WEBGL)) === null || _gl$getParameter5 === void 0 ? void 0 : _gl$getParameter5.toString() : '',
    shadingLanguageVersion: ((_gl$getParameter6 = gl.getParameter(gl.SHADING_LANGUAGE_VERSION)) === null || _gl$getParameter6 === void 0 ? void 0 : _gl$getParameter6.toString()) || ''
  };
}

/**
 * Gets the advanced and massive WebGL parameters and extensions
 */
export function getWebGlExtensions(_ref2) {
  var cache = _ref2.cache;
  var gl = getWebGLContext(cache);
  if (!gl) {
    return STATUS_NO_GL_CONTEXT;
  }
  if (!isValidParameterGetter(gl)) {
    return STATUS_GET_PARAMETER_NOT_A_FUNCTION;
  }
  var extensions = gl.getSupportedExtensions();
  var contextAttributes = gl.getContextAttributes();
  var unsupportedExtensions = [];

  // Features
  var attributes = [];
  var parameters = [];
  var extensionParameters = [];
  var shaderPrecisions = [];

  // Context attributes
  if (contextAttributes) {
    for (var _i = 0, _arr = Object.keys(contextAttributes); _i < _arr.length; _i++) {
      var attributeName = _arr[_i];
      attributes.push("".concat(attributeName, "=").concat(contextAttributes[attributeName]));
    }
  }

  // Context parameters
  var constants = getConstantsFromPrototype(gl);
  for (var _i2 = 0, _constants = constants; _i2 < _constants.length; _i2++) {
    var constant = _constants[_i2];
    var code = gl[constant];
    parameters.push("".concat(constant, "=").concat(code).concat(validContextParameters.has(code) ? "=".concat(gl.getParameter(code)) : ''));
  }

  // Extension parameters
  if (extensions) {
    var _iterator = _createForOfIteratorHelper(extensions),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var name = _step.value;
        if (name === rendererInfoExtensionName && shouldAvoidDebugRendererInfo() || name === polygonModeExtensionName && shouldAvoidPolygonModeExtensions()) {
          continue;
        }
        var extension = gl.getExtension(name);
        if (!extension) {
          unsupportedExtensions.push(name);
          continue;
        }
        for (var _i3 = 0, _getConstantsFromProt = getConstantsFromPrototype(extension); _i3 < _getConstantsFromProt.length; _i3++) {
          var _constant = _getConstantsFromProt[_i3];
          var _code = extension[_constant];
          extensionParameters.push("".concat(_constant, "=").concat(_code).concat(validExtensionParams.has(_code) ? "=".concat(gl.getParameter(_code)) : ''));
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  // Shader precision
  var _iterator2 = _createForOfIteratorHelper(shaderTypes),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var shaderType = _step2.value;
      var _iterator3 = _createForOfIteratorHelper(precisionTypes),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var precisionType = _step3.value;
          var shaderPrecision = getShaderPrecision(gl, shaderType, precisionType);
          shaderPrecisions.push("".concat(shaderType, ".").concat(precisionType, "=").concat(shaderPrecision.join(',')));
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }

    // Postprocess
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  extensionParameters.sort();
  parameters.sort();
  return {
    contextAttributes: attributes,
    parameters: parameters,
    shaderPrecisions: shaderPrecisions,
    extensions: extensions,
    extensionParameters: extensionParameters,
    unsupportedExtensions: unsupportedExtensions
  };
}

/**
 * This function usually takes the most time to execute in all the sources, therefore we cache its result.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
export function getWebGLContext(cache) {
  if (cache.webgl) {
    return cache.webgl.context;
  }
  var canvas = document.createElement('canvas');
  var context;
  canvas.addEventListener('webglCreateContextError', function () {
    return context = undefined;
  });
  for (var _i4 = 0, _arr2 = ['webgl', 'experimental-webgl']; _i4 < _arr2.length; _i4++) {
    var type = _arr2[_i4];
    try {
      context = canvas.getContext(type);
    } catch (_unused) {
      // Ok, continue
    }
    if (context) {
      break;
    }
  }
  cache.webgl = {
    context: context
  };
  return context;
}

/**
 * https://developer.mozilla.org/en-US/docs/Web/API/WebGLShaderPrecisionFormat
 * https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/getShaderPrecisionFormat
 * https://www.khronos.org/registry/webgl/specs/latest/1.0/#5.12
 */
function getShaderPrecision(gl, shaderType, precisionType) {
  var shaderPrecision = gl.getShaderPrecisionFormat(gl[shaderType], gl[precisionType]);
  return shaderPrecision ? [shaderPrecision.rangeMin, shaderPrecision.rangeMax, shaderPrecision.precision] : [];
}
function getConstantsFromPrototype(obj) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var keys = Object.keys(obj.__proto__);
  return keys.filter(isConstantLike);
}
function isConstantLike(key) {
  return typeof key === 'string' && !key.match(/[^A-Z0-9_x]/);
}

/**
 * Some browsers print a console warning when the WEBGL_debug_renderer_info extension is requested.
 * JS Agent aims to avoid printing messages to console, so we avoid this extension in that browsers.
 */
export function shouldAvoidDebugRendererInfo() {
  return isGecko();
}

/**
 * Some browsers print a console warning when the WEBGL_polygon_mode extension is requested.
 * JS Agent aims to avoid printing messages to console, so we avoid this extension in that browsers.
 */
export function shouldAvoidPolygonModeExtensions() {
  return isChromium() || isWebKit();
}

/**
 * Some unknown browsers have no `getParameter` method
 */
function isValidParameterGetter(gl) {
  return typeof gl.getParameter === 'function';
}